import { Observable } from 'rxjs/internal/Observable';
import * as i0 from "@angular/core";
var UtilsService = /** @class */ (function () {
    function UtilsService() {
    }
    UtilsService.prototype.isNullOrUndefined = function (value) {
        try {
            return value === undefined || value === '' || value === null ? true : false;
        }
        catch (error) {
            console.log('isNullOrUndefined', error);
        }
    };
    UtilsService.prototype.changeFile = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = function (error) { return reject(error); };
        });
    };
    UtilsService.prototype.uploadFile = function (event) {
        var _this = this;
        return new Observable(function (subscriber) {
            try {
                var result_1 = { base64: null, file_type: null };
                if (event.target.value) {
                    var file = event.target.files[0];
                    result_1.file_type = file.name.split('.')[1];
                    _this.changeFile(file).then(function (base64) {
                        base64 = base64.replace('data:application/pdf;base64,', '');
                        base64 = base64.replace('data:image/jpeg;base64,', '');
                        result_1.base64 = base64;
                        subscriber.next(result_1);
                    });
                }
            }
            catch (error) {
                subscriber.next(null);
            }
        });
    };
    UtilsService.ngInjectableDef = i0.defineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(); }, token: UtilsService, providedIn: "root" });
    return UtilsService;
}());
export { UtilsService };
